import {
  marketingSalesConstants,
  toastTypes,
} from "../../constants";
import { customToast } from "../../../../shared";
import { marketingSalesService } from "../../services";
import { withSpinner, success } from "../../../../redux/actions/utilities";

const {
  GET_SALES_REPORT,
  GET_MARKETING_SALES,
  GET_TOTAL_EMAIL_AND_SMS_DELIVERED_COUNT,
} = marketingSalesConstants;

//Getting marketing sales campaign metrics data
const getCampaignMetricsData = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_MARKETING_SALES, () =>
      marketingSalesService
        .getCampaignMetricsData(body)
        .then(
          (response) => {
            dispatch(success(response, GET_MARKETING_SALES));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Getting sales report
const getSalesReport = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_SALES_REPORT, () =>
      marketingSalesService
        .getSalesReport(body)
        .then(
          (response) => {
            dispatch(success(response, GET_SALES_REPORT));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

//Getting total sms and email delivered count
const getTotalEmailAndSmsDeliveredCount = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_TOTAL_EMAIL_AND_SMS_DELIVERED_COUNT, () =>
      marketingSalesService
        .getTotalEmailAndSmsDeliveredCount(body)
        .then(
          (response) => {
            dispatch(success(response, GET_TOTAL_EMAIL_AND_SMS_DELIVERED_COUNT));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

export const marketingSalesActions = {
  getSalesReport,
  getCampaignMetricsData,
  getTotalEmailAndSmsDeliveredCount,
};
